
  import axios from "axios";
  import Config from "../../../config/index";
import { GET_GRN_REPORT_DOWNLOAD_FAILURE, GET_GRN_REPORT_DOWNLOAD_REQUEST, GET_GRN_REPORT_DOWNLOAD_SUCCESS, GET_GRN_REPORT_FAILURE, GET_GRN_REPORT_REQUEST, GET_GRN_REPORT_SUCCESS } from "./grnReportTypes";
  let baseUrl = Config.baseUrl;
  
let baseUrlReport = Config.baseUrlReport;
  
  const getGrnReportRequest = () => { 
    return {
      type: GET_GRN_REPORT_REQUEST,
    };
  };
  
  const getGrnReportSuccess = (payload) => {
    return {
      type: GET_GRN_REPORT_SUCCESS,
      payload: payload,
    };
  };
  
  const getGrnReportFailure = (error) => {
    return {
      type: GET_GRN_REPORT_FAILURE,
      payload: error,
    };
  };
  
  const getGrnReport = (pageNo, rowsPerPage, search, jwtToken) => {
    let headers = {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    };
    return (dispatch) => {
      dispatch(getGrnReportRequest());
      let url = `${baseUrlReport}/grn?download=0&page_number=${
        pageNo + 1
      }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&startDate=""&endDate=""`;
      axios
        .get(url, headers)
        .then((response) => {
          dispatch(getGrnReportSuccess(response.data));
        })
        .catch((err) => {
          dispatch(getGrnReportFailure(err.response));
        });
    };
  };
  
  const downloadGrnReportRequest = () => {
    return {
      type: GET_GRN_REPORT_DOWNLOAD_REQUEST,
    };
  };
  
  const downloadGrnReportSuccess = (payload) => {
    return {
      type: GET_GRN_REPORT_DOWNLOAD_SUCCESS,
      payload: payload,
    };
  };
  
  const downloadGrnReportFailure = (error) => {
    return {
      type: GET_GRN_REPORT_DOWNLOAD_FAILURE,
      payload: error,
    };
  };
  
  const downloadGrnReport = (
    startDate,
    endDate,
    pageNo,
    rowsPerPage,
    search,
    jwtToken
  ) => {
    let headers = {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    };
    return (dispatch) => {
      dispatch(downloadGrnReportRequest());
      let url = `${baseUrlReport}/grn?download=1&startDate=${endDate}&endDate=${startDate}&page_number=${
        pageNo + 1
      }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
      axios
        .get(url, headers)
        .then((response) => {
          dispatch(downloadGrnReportSuccess(response.data));
        })
        .catch((err) => {
          dispatch(downloadGrnReportFailure(err.response));
        });
    }; 
  };
  
  export { getGrnReport,
     downloadGrnReport 
    };
  